import React, { useEffect } from 'react';
import { useParams, useNavigate, useSearchParams } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { CheckCircle2 } from 'lucide-react';
import { motion } from 'framer-motion';

const SubmissionSuccess = () => {
  const { submissionId } = useParams();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const sessionId = searchParams.get('session_id');

  useEffect(() => {
    if (!sessionId) {
      navigate(`/submission/${submissionId}/summary`);
    }
  }, [sessionId, submissionId, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center p-6">
      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.4 }}
        className="max-w-md w-full"
      >
        <div className="bg-card rounded-xl border border-border/50 shadow-lg p-8 text-center">
          <div className="bg-emerald-100 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-6">
            <CheckCircle2 className="w-8 h-8 text-emerald-600" strokeWidth={2} />
          </div>

          <h1 className="text-2xl font-bold tracking-tight mb-3" data-testid="success-title">
            Submission Received!
          </h1>
          
          <p className="text-muted-foreground mb-6">
            Your sensory assessment is complete. You can now generate your accessibility guide instantly.
          </p>

          <div className="bg-emerald-50 border border-emerald-200 rounded-lg p-4 mb-6">
            <p className="text-sm font-medium text-emerald-800 mb-1">Ready to Generate</p>
            <p className="text-lg font-semibold text-emerald-700">Your guide is waiting</p>
          </div>

          <p className="text-sm text-muted-foreground mb-6">
            We've sent a confirmation email. Click below to view your summary and generate your guide.
          </p>

          <Button
            onClick={() => navigate(`/submission/${submissionId}/summary`)}
            className="w-full h-11 rounded-full font-medium mb-3"
            data-testid="view-summary-button"
          >
            View Assessment Summary
          </Button>

          <Button
            variant="ghost"
            onClick={() => navigate('/dashboard')}
            className="w-full rounded-full"
            data-testid="dashboard-button"
          >
            Back to Dashboard
          </Button>
        </div>
      </motion.div>
    </div>
  );
};

export default SubmissionSuccess;